
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ChairDetail from "../pages/chair/page";
import RentalService from "../pages/rental/page";
import CoworkingExperience from "../pages/coworking/page";
import AboutCompany from "../pages/about-company/page";
import AccessoriesPage from "../pages/accessories/page";
import TeaPage from "../pages/tea/page";
import ChairLineupPage from "../pages/chair-lineup/page";
import CampaignPage from "../pages/campaign/page";
import AtelierFolioPage from "../pages/atelier-folio/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/chair",
    element: <ChairLineupPage />,
  },
  {
    path: "/chair/:model",
    element: <ChairDetail />,
  },
  {
    path: "/accessories",
    element: <AccessoriesPage />,
  },
  {
    path: "/rental",
    element: <RentalService />,
  },
  {
    path: "/coworking",
    element: <CoworkingExperience />,
  },
  {
    path: "/about-company",
    element: <AboutCompany />,
  },
  {
    path: "/tea",
    element: <TeaPage />,
  },
  {
    path: "/campaign",
    element: <CampaignPage />,
  },
  {
    path: "/atelier-folio",
    element: <AtelierFolioPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
